"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RoomCardAtoms_1 = require("@/common/components/RoomCard/RoomCardAtoms");
const RoomCardMolecules_1 = require("@/common/components/RoomCard/RoomCardMolecules");
function default_1({ roomData, 
// changeLikeStateFn,
// useFondeeSearchApi,
maxWidth768, }) {
    const { id: roomId, thumbnail, payment_approval_cd_id, is_secret, 
    // has_like,
    channel_uid, channel_thumbnail, channel_name, 
    // fee_free,
    // room_type_cd_id,
    title, like_counts, view_counts, } = roomData;
    const commissionViewUrl = `/room/commission-view/${roomId}`;
    const isAdultPlus = payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_05';
    const isAdultOnly = payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_02' || isAdultPlus;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: maxWidth768 ? 'column' : 'row', gap: '8px' } }, { children: [(0, jsx_runtime_1.jsxs)(RoomCardAtoms_1.CardTopWrapper, Object.assign({ viewUrl: commissionViewUrl, maxWidth768: maxWidth768, isHotCommission: true }, { children: [(0, jsx_runtime_1.jsx)(RoomCardAtoms_1.Thumbnail, { thumbnail: thumbnail, roomId: roomId }), isAdultOnly ? ((0, jsx_runtime_1.jsx)(RoomCardAtoms_1.AdultOnlyCover, { isAdultPlus: isAdultPlus, isHotCommission: true })) : is_secret ? ((0, jsx_runtime_1.jsx)(RoomCardAtoms_1.SecretFormCover, {})) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '6px',
                    padding: '0 4px',
                } }, { children: [(0, jsx_runtime_1.jsx)(RoomCardMolecules_1.ChannelLink, { channel_uid: channel_uid, channel_thumbnail: channel_thumbnail, channel_name: channel_name }), (0, jsx_runtime_1.jsx)(RoomCardAtoms_1.Title, { viewUrl: commissionViewUrl, title: title, maxWidth768: maxWidth768, isCommission: true }), (0, jsx_runtime_1.jsx)(RoomCardAtoms_1.LikeViewCounts, { like_counts: like_counts, view_counts: view_counts })] }))] })));
}
exports.default = default_1;
